import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";

loadFonts();
async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: "us-east-1_SjvYsPWgl",
        userPoolClientId: "v30gqeagqbpnlurdk17uipqj3",
        authMode: "userPool",
        loginWith: {
          email: true,
        },
      },
    },

    API: {
      GraphQL: {
        endpoint:
          "https://zx7ecgsocneare7tuoh5jkzou4.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      },
      aws_project_region: "us-east-1",
    },
  });

  const app = createApp(App);

  app.use(router);
  app.use(store);
  app.use(vuetify);
  app.mount("#app");
}

initApp();
